var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-body"},[_c('topMb',{staticClass:"is-mb"}),_c('top',{staticClass:"is-pc"}),_c('div',{staticClass:"box main-content"},[_c('router-view')],1),_c('bottomMb',{staticClass:"is-mb footer"}),_c('bottom',{staticClass:"is-pc footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }